import { useRef, useState } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { useIntl } from "react-intl";
import "./moreActions.scss";
import { Tooltip } from "primereact/tooltip";
import { type } from "@testing-library/user-event/dist/type";

const MoreActions = ({ actions, data, notAllowedKey, notAllowedValue }) => {
  const intl = useIntl();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const op = useRef(null);

  const performAction = (e, action) => {
    e.preventDefault();
    e.stopPropagation();

    const additionalCheckForAllowed = action.additionalCheckForAllowed
      ? action.additionalCheckForAllowed(data)
      : true;

    if (action.isAllowed && additionalCheckForAllowed && action.action) {
      op.current.toggle(e);
      action.action(data);
    }
  };

  const isNotAllowed =
    (notAllowedKey && data?.[notAllowedKey] === notAllowedValue) || false;

  const getNotAllowedMessage = (action) => {
    if (
      action?.additionalCheckNotAllowedMessage &&
      typeof action?.additionalCheckNotAllowedMessage === "function"
    ) {
      return action.additionalCheckNotAllowedMessage(data);
    } else {
      return action?.additionalCheckNotAllowedMessage || "no_permission";
    }
  };

  return (
    (!isNotAllowed && (
      <div className="edexlms-other-actions flex justify-content-center align-items-center">
        <div
          className="edexlms-other-actions-trigger flex justify-content-center align-items-center"
          style={{ width: "50px", height: "50px" }}
          onClick={(e) => {
            e.stopPropagation();
            setIsMenuOpen(!isMenuOpen);
            op.current.toggle(e);
          }}
        >
          <span className="pi pi-ellipsis-v"></span>
        </div>
        <OverlayPanel
          ref={op}
          onHide={(e) => setIsMenuOpen(false)}
          className="p-0 edexlms-other-actions-menu-overlay"
          onClick={(e) => e.stopPropagation()}
        >
          <Tooltip target=".edexlms-other-actions-menu-item.disabled" />
          <ul>
            {actions
              .filter((action) => {
                if (action?.hidden?.field) {
                  return data[action?.hidden?.field] !== action?.hidden?.value;
                }
                return true;
              })
              .map((action) => {
                const isActionAllowed =
                  action.isAllowed &&
                  (action.additionalCheckForAllowed
                    ? action.additionalCheckForAllowed(data)
                    : true);
                return (
                  <li
                    className={`edexlms-other-actions-menu-item ${
                      !isActionAllowed ? "disabled" : ""
                    }`}
                    data-pr-tooltip={intl.formatMessage({
                      id: (
                        action.additionalCheckForAllowed
                          ? !action.additionalCheckForAllowed(data)
                          : false
                      )
                        ? getNotAllowedMessage(action)
                        : "no_permission",
                    })}
                    data-pr-position="left"
                    key={action.label}
                    onClick={(e) => performAction(e, action)}
                  >
                    <span className={`pi ${action.icon} mr-2`}></span>
                    <span>{intl.formatMessage({ id: action.label })}</span>
                  </li>
                );
              })}
          </ul>
        </OverlayPanel>
      </div>
    )) ||
    null
  );
};

export default MoreActions;
